import React from "react";

import { Box, BoxProps } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    overflow: "hidden",
    overflowY: "auto",
    height: "100%",
    // On mobile the panels stack, so let the container grow to its content and
    // scroll with the page instead of creating a nested scrollbar.
    [theme.breakpoints.down("md")]: {
      overflow: "visible",
      overflowY: "visible",
      height: "auto",
    },
  },
}));

interface VerticalScrollContainerProps extends BoxProps {
  children: React.ReactNode;
}

export const VerticalScrollContainer: React.FC<
  VerticalScrollContainerProps
> = ({ children, ...props }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container} {...props}>
      {children}
    </Box>
  );
};
